<template>
  <div
    :class="{
      'confirmation-edit-modal-mobile': mq.current === 'mobile',
      'confirmation-edit-modal-desktop': mq.current !== 'mobile'
    }"
  >
    <div 
      v-if="mq.current === 'mobile'" 
      class="title-mobile">
      <AmTypography
        :text="$t('confirmationToEditModal.title')"
        color="appmaxDark"
        weight="medium"
        typographyStyle="l4"
      />
      <AmButton
        variant="maxGhost"
        :icon="{ name: 'close', size: 'small' }"
        position="withLeftIcon"
        size="iconSmall"
      />
    </div>

    <div>
      <AmTypography
        :text="$t('confirmationToEditModal.content')"
        color="appmaxDark"
        typographyStyle="l6"
      />
      <AmTypography
        :text="$t('confirmationToEditModal.contentConfirmation')"
        color="appmaxDark"
        typographyStyle="l6"
      />
    </div>

    <div 
      class="actions">
      <AmButton
        :label="$t('confirmationToEditModal.actions.cancel')"
        variant="maxGhost"
        size="xlarge"
      />
      <AmButton
        :label="$t('confirmationToEditModal.actions.edit')"
        variant="maxPrimary"
        size="xlarge"
      />
    </div>
  </div>
</template>

<script>
import { AmTypography, AmButton } from '@appmax_npm/ds-appmax-v3'
import './ConfirmationToEditModal.scss'

export default {
  name: 'ConfirmationToEditModal',
  inject: ['mq'],
  components: {
    AmTypography,
    AmButton
  }
}
</script>
